import React from 'react'
import TrophyIcon from '../../public/stepper/trophy.svg'
import { useTranslation } from '../../lib/i18n'

const Complete = ({ hide }) => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col justify-between items-center gap-1 mt-2">
      <TrophyIcon className="w-20 h-14" />
      <p className="text-black text-center text-sm w-64">
        {t('onboarding.completeMessage')}
      </p>
      <button onClick={hide} className="text-disabled text-sm">
        {t('onboarding.closeThis')}
      </button>
    </div>
  )
}

export default Complete
